import React from 'react';
import { Row, Col } from 'src/componentes/grid';
import { autobind } from 'core-decorators';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import http from 'src/services/httpService';

import Edit from 'src/componentes/edit/edit-dialog';
import { Schema } from 'src/utils/form';
import ColaboradorSimplificadoLookup from 'src/lookups/ColaboradorSimplificadoLookup';
import TipoAcessoLookup from 'src/lookups/tipo-acesso';
import { capitalizeFirstLetter } from 'src/utils/string';
import ContentManager from 'src/componentes/content-manager';
import Alert from 'src/componentes/message-box/alert';
import errorHandler from 'src/utils/error-handler';

let schema = Schema.object({
  tipoAcesso: Schema.string()
    .label(<FormattedMessage id="label.tipoAcesso" />)
    .required(),
  colaborador: Schema.string()
    .label()
    .required({
      onlyIf: (context) => {
        return context.parent.value.colaborador;
      },
    }),
  colaboradores: Schema.array()
    .label('')
    .required({
      onlyIf: (context) => {
        return !context.parent.value.colaborador;
      },
    }),
});

@autobind
class FormEdit extends React.Component {
  render() {
    let { model, resources, intl } = this.props;
    let isNew = model.value.id === 0;

    return (
      <Row>
        <Col md={8}>
          {isNew ? (
            <ColaboradorSimplificadoLookup
              multi
              required
              clearable={false}
              model={{
                label: capitalizeFirstLetter(resources.colaboradores),
                value: model.getModel('colaboradores').value,
                requestChange: model.getModel('colaboradores').requestChange,
                errors: model.getModel('colaboradores').errors,
              }}
            />
          ) : (
            <ColaboradorSimplificadoLookup
              required
              clearable={false}
              model={{
                label: capitalizeFirstLetter(resources.colaborador),
                value: model.getModel('colaborador').value,
                requestChange: model.getModel('colaborador').requestChange,
                errors: model.getModel('colaborador').errors,
              }}
            />
          )}
        </Col>
        <Col md={4}>
          <TipoAcessoLookup
            required
            clearable={false}
            model={{
              label: capitalizeFirstLetter(
                intl.formatMessage({ id: 'tipoAcesso' })
              ),
              value: model.getModel('tipoAcesso').value,
              requestChange: model.getModel('tipoAcesso').requestChange,
              errors: model.getModel('tipoAcesso').errors,
            }}
          />
        </Col>
      </Row>
    );
  }
}

class ItemPermissaoEdit extends React.Component {
  render() {
    const isNew = !this.props.item;

    const handleSave = (model, handleClose) => {
      http
        .post(`${this.props.url}/AdicionaNovasPermissoes`, {
          model,
          parameters: {
            itemId: this.props.parameters.itemId,
          },
          isNew,
        })
        .then(() => {
          handleClose();

          ContentManager.addContent(
            <Alert
              title={this.props.intl.formatMessage({ id: 'sucesso' })}
              message={this.props.intl.formatMessage({
                id: this.props.messageSave,
              })}
            />
          );
        })
        .catch((error) => {
          this.setState({
            isLoading: false,
            checkRequiredCustom: this.state.checkRequiredCustom + 1,
          });

          errorHandler(error);
        });
    };

    return (
      <Edit
        url={this.props.parameters && this.props.parameters.url}
        title="label.permissoesDeAcesso"
        formComponent={FormEdit}
        schema={schema}
        width={700}
        minHeight={250}
        handleSave={isNew ? handleSave : undefined}
        {...this.props}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    resources: state.user.termos,
  };
}
export default injectIntl(connect(mapStateToProps)(ItemPermissaoEdit));
